
/* User defined models */
export class Direction {
  name: string;
  generalMemo: string;
  schedulingMemo: string;
  direction: string;

  constructor(
    name: string,
    generalMemo: string,
    schedulingMemo: string,
    direction: string
  ) {
    this.name = name;
    this.generalMemo = generalMemo;
    this.schedulingMemo = schedulingMemo;
    this.direction = direction;
  }
}